import { Suspense } from "react";
import FallBackUI from "../Components/FallBackUI";
import ProtectedRoute from "../Components/ProtectedRoute";
import Components from "./Components";
import PageNotFound from "../pages/PageNotFound";
import { LoginRoute } from "./LoginRoute";

export const routes = [
  {
    path: "/login",
    element: (
      <Suspense fallback={<FallBackUI />}>
        <LoginRoute component={Components.Login} />
      </Suspense>
    ),
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Components.Home />
      </ProtectedRoute>
    ),
  },
  {
    path: "/profile",
    element: (
      <ProtectedRoute>
        <Components.Profile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/patient_transport",
    element: (
      <ProtectedRoute>
        <Components.PatientTransport />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
];
